import React from 'react'
import { Link } from 'react-router-dom'
import { imageUrl } from '../lib/images'

export default function AboutPage() {
  return (
    <div className="py-10 sm:py-16 space-y-16">
      {/* Intro section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7 space-y-6">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#241F1C] tracking-tight leading-tight">
              Passion for god mad og uforglemmelige selskaber
            </h1>
            <p className="text-sm sm:text-base md:text-lg text-[#6E635C] leading-relaxed">
              Hos Overgaard Pattegrise sætter vi pris på godt håndværk og bruger råvarer af høj kvalitet –
              og det kan altså smages! Vi leverer grillmad og catering til både små og store selskaber
              i Sønder Omme og omegn.
            </p>

            <div className="pt-2 flex flex-wrap gap-3 sm:gap-4">
              <Link
                to="/bestil"
                className="inline-flex items-center gap-2 bg-[#C25E27] hover:bg-[#A84E1C] text-white px-5 py-2.5 sm:px-7 sm:py-3.5 font-bold text-xs sm:text-sm transition-shadow duration-300 hover:shadow-lg cta-hop"
              >
                <i className="fa-solid fa-utensils text-xs sm:text-sm" aria-hidden="true" />
                <span>Sammensæt din menu</span>
              </Link>
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 bg-transparent text-[#241F1C] border border-[#241F1C]/40 px-5 py-2.5 sm:px-6 sm:py-3.5 font-bold text-xs sm:text-sm transition-colors"
              >
                <span>Kontakt os</span>
              </Link>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="overflow-hidden aspect-[4/3]">
              <img
                src={imageUrl('/_assets/img-4536.jpeg', 'width=800,quality=80,format=auto')}
                alt="Grillmesteren og helstegt pattegris hos Overgaard"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CORE VALUES (Text from prompt/Festgrisen reference adapted) */}
      <section className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-7xl mx-auto space-y-8">
            <div className="text-center">
              <h2 className="text-2xl sm:text-3xl font-extrabold text-[#241F1C]">
                Vi sætter rammen for dit arrangement
              </h2>
            </div>

            <div className="space-y-6 text-[#241F1C] text-sm sm:text-base leading-relaxed">
              <p>
                Vi ved, at vi er med til at sætte rammen for dit arrangement – og det ansvar bærer vi med glæde.
              </p>
              <p>
                Det er vigtigt for os, at du får en god oplevelse. Derfor møder vi altid op med et smil og
                bidrager til en god, afslappet stemning til din fest.
              </p>
              <div className="p-6 bg-white border-l-4 border-[#C25E27] shadow-md">
                <h3 className="font-bold text-[#241F1C] text-lg">En aftale er en aftale</h3>
                <p className="text-sm text-[#6E635C] mt-1">
                  Hos os betyder det, at vi møder op og står klar til tiden – så dine gæster ikke sidder med
                  knurrende maver og venter på maden.
                </p>
              </div>
              <p>
                Vi brænder for at sprede glæde gennem et godt måltid. Når du bestiller hos Overgaard Pattegrise,
                kan du være sikker på, at både grise, stegebuffet og tilbehør er af højeste kvalitet.
              </p>
            </div>
          </div>
        </div>
      </section>


    </div>
  )
}
